import { type ComponentPropsWithoutRef } from 'react';
import { FilterContent } from '@/module/public/components/AsideFilter/FilterContent';
import { cn } from '@/utils';
import { FilterHeader } from './FilterHeader';
export const AsideFilter = () => {
  return <div className={cn('flex w-[286px] h-full flex-col items-start', 'shadow-md bg-default border-alternative rounded-md')} data-sentry-component="AsideFilter" data-sentry-source-file="AsideFilter.tsx">
      <FilterHeader data-sentry-element="FilterHeader" data-sentry-source-file="AsideFilter.tsx" />
      <FilterContent data-sentry-element="FilterContent" data-sentry-source-file="AsideFilter.tsx" />
    </div>;
};
export const FilterMenuItem = (props: ComponentPropsWithoutRef<'div'>) => {
  const {
    className,
    children,
    ...rest
  } = props;
  return <div className={cn('flex self-stretch py-xs  w-full px-md', 'cursor-pointer items-center gap-xs', className)} {...rest} data-sentry-component="FilterMenuItem" data-sentry-source-file="AsideFilter.tsx">
      {children}
    </div>;
};